import React, { PropsWithChildren } from 'react';
import styles from './dictionary-components.module.scss';

export default function AkCyan({ children }: PropsWithChildren<{}>) {
    return <span className={styles.wwiseAkCyan}>{children}</span>;
}
